<script>
//Repositories
import Repositories from '@/repositories';
const AllocationsRepository = Repositories.get('allocations');
const ItemsRepository = Repositories.get('items');

export default {
  props: {
    modalId: { type: String, default: 'update-allocation-modal' },
    item: { type: Object },
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      selectedAllocationIdPublic: null,
      allocationsList: [],
      allocationsGroupedList: [],
    };
  },
  created() {
    this.loadAllocations();
  },
  methods: {
    loadAllocations() {
      AllocationsRepository.getAll().then(({ data }) => {
        if (data != null && data.data != null) {
          this.allocationsList = data.data;

          this.allocationsGroupedList = data.data.reduce((acc, allocation) => {
            let allocationGroupIdPublic = allocation.allocationGroupIdPublic;
            let allocationGroupName = allocation.allocationGroupName;

            let group = acc.find(
              (group) =>
                group.allocationGroupIdPublic === allocationGroupIdPublic
            );
            if (!group) {
              group = {
                allocationGroupName: allocationGroupName,
                allocationGroupIdPublic: allocationGroupIdPublic,
                allocations: [],
              };
              acc.push(group);
            }

            group.allocations.push({
              name: allocation.name,
              idPublic: allocation.idPublic,
            });

            return acc;
          }, []);
        }
      });
    },
    modalShow() {
      this.isLoading = false;
      this.isError = false;
      if (this.item !== null) {
        this.selectedAllocationIdPublic = this.item.allocationIdPublic;
      } else {
        this.selectedAllocationIdPublic = null;
      }
    },
    modalHidden() {
      this.selectedAllocationIdPublic = null;
      this.$emit('modal-closed');
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
    saveAllocation() {
      let allocationIndex = this.allocationsList.findIndex(
        (x) => x.idPublic == this.selectedAllocationIdPublic
      );

      if (allocationIndex >= 0) {
        this.isError = false;
        this.isLoading = true;

        let allocationObject = this.allocationsList[allocationIndex];
        let apiWrapper = {
          ...this.item,
          allocationIdPublic: allocationObject.idPublic,
          allocationName: allocationObject.name,
        };

        ItemsRepository.update(apiWrapper, this.item.idPublic)
          .then(() => {
            this.$emit('item-updated', apiWrapper);
            this.closeModal();
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isError = true;
          })
          .finally(() => (this.isLoading = false));
      }
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      :id="modalId"
      :title="$t('general.update')"
      centered
      size="md"
      @show="modalShow()"
      @hide="modalHidden()"
    >
      <b-form-select
        style="width: 100%"
        v-model="selectedAllocationIdPublic"
        :options="allocationsGroupedList"
        value-field="idPublic"
        text-field="name"
        label-field="allocationGroupName"
        options-field="allocations"
        :placeholder="$t('general.pickAValue')"
      >
      </b-form-select>

      <template #modal-footer>
        <b-button @click="closeModal()" :disabled="isLoading" variant="danger">
          {{ $t('general.cancel') }}
        </b-button>
        <b-button
          @click="saveAllocation()"
          :disabled="isLoading || selectedAllocationIdPublic == null"
          style="min-width: 100px"
          variant="success"
        >
          <i v-if="isLoading" class="bx bx-loader-alt bx-spin text-warning">
          </i>
          <i v-else-if="isError" class="fas fa-exclamation text-danger"></i>
          <span v-else>
            {{ $t('general.save') }}
          </span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>